import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Color } from 'ng2-charts';


@Component({
  selector: 'gen-pcr-graph',
  templateUrl: './pcr-graph.component.html',
  styleUrls: ['./pcr-graph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PcrGraphComponent implements OnInit {
  @Input()
  public graphCoordinates: string[];
  public xLabels: Array<number> = Array.from(Array(13).keys()).slice(1, 13);
  public yLabels: Array<string> = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  public lineChartType: string = 'line';
  public graphColor: Array<Color> = [{ backgroundColor: '#e6e6e6'}];
  public dataMap: Map<number, number[]>;
  public min: number = 0;
  public max: number = 0;

  constructor() {
    this.dataMap = new Map();
  }


  ngOnInit() {
    this.getPayload();
  }

  private getPayload() {
    this.fillDataMap(this.graphCoordinates);
    this.setGraphPointsRange();
  }


  private setGraphPointsRange() {
    const flatternPoints = [].concat(...Array.from(this.dataMap.values()));
    this.min = Math.min(...flatternPoints);
    this.max = Math.max(...flatternPoints);
  }

  private fillDataMap(data: Array<string>) {
    for (const item of data) {
      const itemObj: any = JSON.parse(item);
      this.dataMap.set(Number(itemObj.id), itemObj.data.adp.map(item => item.fluor));
    }
  }

  public lineChartOptions() {
    return {
      responsive: true,
      animation: false,
      data: [],
      hover: { mode: null},
      scales: {
        yAxes: [{
          display: false,
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            labelString: 'probability'
          },
          ticks: {
            min: this.min,
            max: this.max
          }
        }],
        xAxes: [{
          display: false,
          gridLines: {
            display: false
          }
        }]
      },
      elements: {
        display: false,
        point: { radius: 0, display: false, hoverRadius: 0, hoverBorderWidth: 0, hitRadius: 0}
      }
    };
  }


  public getArray(len: number) {
    return Array.from(Array(len).keys());
  }

  public getDataScore(id: number) {
    if (this.dataMap.get(id)) {
      return this.dataMap.get(id);
    }
    return [];
  }

  public getDataLabels(id: number) {
    if (this.dataMap.get(id)) {
      const res = this.dataMap.get(id);
      return this.getArray(res.length);
    }
    return [];
  }

  public dataIsAvailable(): boolean {
    return this.dataMap.size > 0;
  }

}

